export default function CredibilityStats() {
  const stats = [
    { number: '20+', label: 'Years Experience' },
    { number: '3,600+', label: 'Units Built or Renovated' },
    { number: '$225M+', label: 'in Completed Contract Work' },
    { number: '7', label: 'States Served' },
  ];

  return (
    <section className="relative bg-white py-20">
      {/* Gold Accent Line */}
      <div className="absolute top-0 left-0 right-0 h-1 bg-[#C5A55A]"></div>

      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="text-center"
            >
              <div className="text-5xl lg:text-6xl font-bold text-[#1A1A1A] mb-3">
                {stat.number}
              </div>
              <div className="text-base lg:text-lg text-gray-600 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}